import fetchWrapper from '../fetchWrapper';
import { CloudProvider } from 'js/project/nds/types/provider';
import {
  CloudProviderAccess,
  CloudProviderAccessAWSAccountDetails,
  CloudProviderAccessAWSIAMRole,
} from 'js/project/nds/types/cloudProviderAccess';

function fetchCloudProviderAccess(groupId: string): Promise<CloudProviderAccess> {
  return fetchWrapper(`/nds/${groupId}/cloudProviderAccess`, {
    method: 'GET',
  }).then((resp) => resp.json());
}

function deleteCloudProviderAccessAWSIAMRole(groupId: string, role: CloudProviderAccessAWSIAMRole): Promise<Response> {
  return fetchWrapper(`/nds/${groupId}/cloudProviderAccess/${CloudProvider.AWS}/${role.roleId}`, {
    method: 'DELETE',
  });
}

function postCloudProviderAccessAWSIAMRole(
  groupId: string,
  awsIamRole: Partial<CloudProviderAccessAWSIAMRole> = {}
): Promise<CloudProviderAccessAWSIAMRole> {
  return fetchWrapper(`/nds/${groupId}/cloudProviderAccess`, {
    method: 'POST',
    body: JSON.stringify({
      ...awsIamRole,
      providerName: CloudProvider.AWS,
    }),
  }).then((resp) => resp.json());
}

function patchCloudProviderAccessAWSIAMRole(
  groupId: string,
  awsIamRole: CloudProviderAccessAWSIAMRole
): Promise<CloudProviderAccessAWSIAMRole> {
  return fetchWrapper(`/nds/${groupId}/cloudProviderAccess/${awsIamRole.roleId}`, {
    method: 'PATCH',
    body: JSON.stringify({
      ...awsIamRole,
      providerName: CloudProvider.AWS,
    }),
  }).then((resp) => resp.json());
}

function getAtlasAWSAccountDetails(groupId: string): Promise<CloudProviderAccessAWSAccountDetails> {
  return fetchWrapper(`/nds/${groupId}/cloudProviderAccess/${CloudProvider.AWS}/atlasAccountDetails`, {
    method: 'GET',
  }).then((resp) => resp.json());
}

export {
  fetchCloudProviderAccess,
  deleteCloudProviderAccessAWSIAMRole,
  postCloudProviderAccessAWSIAMRole,
  patchCloudProviderAccessAWSIAMRole,
  getAtlasAWSAccountDetails,
};
